// extracted by mini-css-extract-plugin
module.exports = {"history":"trading-history_history__BXXdO","header":"trading-history_header__EfgsV","event":"trading-history_event__1ZbNt","activity":"trading-history_activity__3wO_J"};